/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import Vue from 'vue';
// import store from '@/store';
import Proxy from '@/proxies/AuthProxy';
import * as types from './mutation-types';

export const check = ({ commit }) => {
  commit(types.CHECK);
};

export const register = ({ commit }) => {
  commit(types.LOGIN, 'RandomGeneratedToken');
  Vue.router.push({
    name: 'home.index',
  });
};

export const login = ({ commit, dispatch }, payload) => {
  dispatch('wait/start', 'global loading', { root: true });
  return new Proxy()
    .login(payload)
    // eslint-disable-next-line
    .then((response) => {
      if (!response.twoFa) {
        let to = null;
        if (localStorage.getItem('prevUrl')) {
          to = JSON.parse(localStorage.getItem('prevUrl'));
          localStorage.removeItem('prevUrl');
        }
        commit(types.LOGIN, response);
        if (payload.to) {
          Vue.router.push({
            path: payload.to,
            query: {
              isNavbarHidden: 1,
            },
          });
        } else if (to && to.name !== 'login') {
          Vue.router.push({
            name: to.name,
            query: to.query,
            params: to.params,
          });
        } else {
          Vue.router.push({
            name: 'home.index',
          });
        }
      } else {
        return response;
      }
    });
};
// eslint-disable-next-line
export const logout = ({ commit, dispatch }, loggedOut) => {
  dispatch('wait/start', 'global loading', { root: true });
  if (!loggedOut) {
    return new Proxy().logout().then(() => {
      commit(types.LOGOUT);
    });
  }
  commit(types.LOGOUT);
};

export default {
  check,
  register,
  login,
  logout,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js